var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title)?_c('h1',[_c('span',[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v("-"+_vm._s(_vm.type ? '剩余可售' : '')+"房源价格")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }